import React from 'react';
import { Mail, Calendar } from "lucide-react";
import { Button } from "../../tailwind/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../tailwind/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../../tailwind/dialog";
import { cn } from "../../../lib/utils";
import { Input } from '../../tailwind/input';

export const AnalyticsHeader = ({ 
  dateRange, 
  setDateRange, 
  emailReportOpen, 
  setEmailReportOpen,
  reportEmail,
  setReportEmail,
  reportFrequency,
  setReportFrequency,
  onScheduleReport
}) => {
  return (
    <div className="flex items-center gap-3">
      <Select value={dateRange} onValueChange={setDateRange}>
        <SelectTrigger className="w-[140px] bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800">
          <SelectValue placeholder="Date Range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="30">Last 30 days</SelectItem>
        </SelectContent>
      </Select>

      <Dialog open={emailReportOpen} onOpenChange={setEmailReportOpen}>
        <DialogTrigger asChild>
          {/* Email Report CTA intentionally hidden for now */}
        </DialogTrigger>
        <DialogContent className="sm:max-w-md bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-gray-900 dark:text-white">
              <Mail className="h-5 w-5 text-[hsl(158,45%,55%)]" />
              Email Report
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-gray-500 dark:text-gray-400">Schedule or send instantly</p>
          
          <div className="space-y-4 mt-4">
            <div>
              <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Email Recipients</label>
              <Input 
                placeholder="email@example.com"
                value={reportEmail}
                onChange={(e) => setReportEmail(e.target.value)}
                className="mt-1 bg-white dark:bg-slate-950 border-gray-200 dark:border-slate-800"
              />
              <p className="text-xs text-gray-400 mt-1">Separate multiple emails with commas</p>
            </div>
            
            <div>
              <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Frequency</label>
              <div className="grid grid-cols-2 gap-2 mt-2">
                {["once", "daily", "weekly", "monthly"].map((freq) => (
                  <Button
                    key={freq}
                    variant={reportFrequency === freq ? "default" : "outline"}
                    className={cn(
                      "capitalize border-gray-200 dark:border-slate-800",
                      reportFrequency === freq 
                        ? "bg-[hsl(158,48%,36%)] hover:bg-[hsl(158,48%,30%)] text-white border-transparent" 
                        : "bg-white dark:bg-slate-950 text-gray-700 dark:text-gray-300"
                    )}
                    onClick={() => setReportFrequency(freq)}
                  >
                    {freq === "once" ? "Send Once" : freq}
                  </Button>
                ))}
              </div>
            </div>

            {reportFrequency !== "once" && (
              <div className="bg-gray-50 dark:bg-slate-800 rounded-lg p-3 flex items-center gap-2">
                <Calendar className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                <span className="text-sm text-gray-600 dark:text-gray-300">
                  Reports will be sent every {reportFrequency === "daily" ? "day" : reportFrequency === "weekly" ? "week" : "month"} at 9:00 AM
                </span>
              </div>
            )}

            <div className="flex gap-2 pt-2">
              <Button 
                type="button"
                variant="outline" 
                className="flex-1 border-gray-200 dark:border-slate-800 text-gray-700 dark:text-gray-300" 
                onClick={() => setEmailReportOpen(false)}
              >
                Cancel
              </Button>
              <Button 
                className="flex-1 bg-[hsl(158,48%,36%)] hover:bg-[hsl(158,48%,30%)] text-white gap-2"
                onClick={onScheduleReport}
              >
                <Mail className="h-4 w-4" />
                {reportFrequency === "once" ? "Send Now" : "Schedule Report"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
